import React from 'react'
import { Outlet } from 'react-router-dom'

function SectionContainer() {
  return (
    <div><Outlet/></div>
  )
}

export default SectionContainer